import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { getLeftCheckedMailProcessingCenters, getRightCheckedMailProcessingCenters } from '../../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/tables/ListTable';
import { getColumns, getData, getIsLoading } from '../redux/selectors/RfidMovementCountReportSelectors';
import RfidMovementCountReportSelectionCriteriaContainer from './RfidMovementCountReportSelectionCriteriaContainer';
import downloadTypes from '../../../../common/tables/excel/DownloadTypes';
import { setGlobalEndDateSelectionActionCreator, setGlobalStartDateSelectionActionCreator } from '../../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';
import { getGlobalEndDate, getGlobalStartDate } from '../../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';

const leftTree = {
  title: 'Outbound Operator/IMPCs',
  useGlobalPresets: false,
};
const rightTree = {
  title: 'Inbound Operator/IMPCs',
  useGlobalPresets: false,
};

class RfidMovementCountReportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedStartDate: this.props.globalStartDate,
      selectedEndDate: this.props.globalEndDate,
    };
  }

  onStartDateChange = (newDate) => {
    this.setState({
      selectedStartDate: newDate,
    });
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onEndDateChange = (newDate) => {
    this.setState({
      selectedEndDate: newDate,
    });
    this.props.setGlobalEndDateSelectionActionCreator(newDate);
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: 'REPORTING_RFID_MOVEMENT_COUNT' },
      this.props.appContext.appContext,
      {
        startDate: this.state.selectedStartDate,
        endDate: this.state.selectedEndDate,
        outboundImpcs: this.props.leftCheckedMailProcessingCenters,
        inboundImpcs: this.props.rightCheckedMailProcessingCenters,
      },
    );
  };

  render() {
    const { isLoading, data, columns } = this.props;
    const { showResult, selectedStartDate, selectedEndDate } = this.state;

    return (
      <div>
        <RfidMovementCountReportSelectionCriteriaContainer
          open={data.length === 0}
          title="RFID Movement Counts"
          onApply={this.onCriteriaApply}
          selectedStartDate={selectedStartDate}
          onStartDateChange={this.onStartDateChange}
          selectedEndDate={selectedEndDate}
          onEndDateChange={this.onEndDateChange}
          leftTree={leftTree}
          rightTree={rightTree}
        />
        <div className="general-content-container">
          {(showResult || data.length > 0) && (
            <div className="full-width">
              <div className="list-table-container" style={{ paddingBottom: '20px', minHeight: '740px' }}>
                <ListTable
                  listId={TableDefinitions.REPORTING_RFID_MOVEMENT_COUNT.id}
                  loading={isLoading}
                  columns={columns}
                  data={data}
                  keyField="id"
                  selectCheckbox
                  downloadType={downloadTypes.EXCEL}
                  downloadFileAs="RFID_MOVEMENT_COUNT"
                  pagination
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

RfidMovementCountReportContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  leftCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  rightCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  isLoading: PropTypes.bool,
  globalStartDate: PropTypes.instanceOf(Date),
  globalEndDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
  setGlobalEndDateSelectionActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    globalStartDate: getGlobalStartDate(state),
    globalEndDate: getGlobalEndDate(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  setGlobalStartDateSelectionActionCreator,
  setGlobalEndDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RfidMovementCountReportContainer);
